/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { KeysPipe } from './keys.pipe';

@NgModule({
    imports: [KeysPipe],
    exports: [KeysPipe],
    providers: [KeysPipe],
})
export class PipeModule {}
